import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface IAIInterface {
  aiSums?: any;
}

const TarrifResults: React.FC = () => {
  const toPercentage = (value: number): string => {
    if (value < 0 || value > 1) {
      throw new Error('Value must be between 0 and 1');
    }
    return `${(value * 100).toFixed()}%`;
  };
  return (
    <div className='screening-ai-containers'>
      <div className='screening-ai-row'>
        <div className='screening-ai-label-text'>
          <AutoAwesomeIcon sx={{ marginRight: '10px', color: '#4895ef' }}/>
          Calculation Summary
        </div>
      </div>
      <div className='screening-ai-sums-cont'>
        <div style={{ marginTop: '15px' }}>
          <div className='screening-ai-sum-groups'>
            <div className='screening-ai-sum-header-texts'>
            Base: 0.9%
            </div>
          </div>
          <div className='screening-ai-sum-groups'>
            <div className='screening-ai-sum-header-texts'>
            + 29%
            </div>
          </div>
          <div className='screening-ai-sum-groups'>
            <div className='screening-ai-sum-header-texts'>
            + 28.2/kg
            </div>
          </div>

          <div className='screening-ai-sum-group-summary' style={{ paddingTop: '10px' }}>
            <div className='screening-ai-sum-result-texts'>
            = 29.9% 28.2/kg
            </div>
          </div>
        </div>
      </div>
      <div className='screening-ai-row-bottom'>
        <div className='screening-ai-label-text-total'>
          Total
        </div>
        <div className='screening-ai-label-text'>
        29.9% 28.2/kg
        </div>
      </div>
    </div>
  );
};


export default TarrifResults;
